import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./GeneralAssembly.style.css";

const GeneralAssembly = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  // Birden fazla tabloyu destekleyen veri yapısı
  const groups = [
    {
      year: "2025",
      docs: [
        // {
        //   name: { tr: "Olağan Genel Kurul Bilgilendirme Dokümanı", en: "Ordinary General Assembly Information Document" },
        //   href: { tr: "/static/docs/2025/info-tr.pdf", en: "/static/docs/2025/info-en.pdf" },
        // },
        // {
        //   name: { tr: "Olağan Genel Kurul Davet İlanı ve Gündem", en: "Invitation & Agenda" },
        //   href: { tr: "/static/docs/2025/agenda-tr.pdf", en: "/static/docs/2025/agenda-en.pdf" },
        // },
        // {
        //   name: { tr: "Olağan Genel Kurul Tutanağı", en: "Minutes of Meeting" },
        //   href: { tr: "/static/docs/2025/minutes-tr.pdf", en: "/static/docs/2025/minutes-en.pdf" },
        // },
        // {
        //   name: { tr: "Olağan Genel Kurul Haziran Listesi", en: "Attendance List" },
        //   href: { tr: "/static/docs/2025/attendance-tr.pdf", en: "/static/docs/2025/attendance-en.pdf" },
        // },
        // {
        //   name: { tr: "Vekaleten Oy Kullanma", en: "Proxy Voting Form" },
        //   href: { tr: "/static/docs/2025/proxy-tr.pdf", en: "/static/docs/2025/proxy-en.pdf" },
        // },
        {
          name: { tr: "Genel Kurul İç Yönerge", en: "Internal Directive" },
          href: { tr: "/static/docs/2025/directive-tr.pdf", en: "/static/docs/2025/directive-en.pdf" },
        },
      ],
    },
    // { year: "2024", docs: [...] }  // yeni yılları ekle
  ];

  return (
    <div>
      <Meta
        title={t("general-assembly")}
        description={t("general-assembly")}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        {/* Hero’yu mevcut görselle bırakıyorum */}
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("general-assembly")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="ga-content">
            {groups.map((g) => (
              <section key={g.year} className="ga-card">
                {/* Yıl başlığı */}
                <div className="ga-year">{g.year}</div>

                {/* Doküman satırları */}
                <ul className="ga-list">
                  {g.docs.map((d, i) => (
                    <li key={i} className="ga-row">
                      <span className="ga-title">{d.name[L] || d.name.en}</span>
                      <a
                        href={d.href[L] || d.href.en}
                        target="_blank"
                        rel="noreferrer"
                        className="ga-dl"
                        aria-label={(t("download") || "İndir") + ": " + (d.name[L] || d.name.en)}
                      >
                        <LuDownload size={18} />
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </main>
        </div>
      </div>
    </div>
  );
};

export default GeneralAssembly;
